<template>
  <alert portal="alerts_add_product_page" @retry="$emit('retry')" :key="id || $vnode.key">
    <slot></slot>
  </alert>
</template>

<script>
import Alert from "../../../components/ui/Alert";

export default {
  name: "AddProductAlert",
  components: {
    alert: Alert,
  },
  props: {
    id: {
      type: String,
      default: null
    }
  }
}
</script>
